/**
 * PROP-086: единственный держатель токена сессии В ПАМЯТИ.
 *
 * Токен больше не хранится в localStorage (уводился любым XSS). Персистентный носитель
 * аутентификации браузер↔API — httpOnly-cookie (её ставит бэк, из JS недоступна). Но десяткам
 * мест в коде нужен сам ТОКЕН в JS — как body-параметр запроса, для гейтов авторизации, для
 * CASL-прав, для HTML-SDK и для AI-сервиса на другом origin, куда cookie не приложится.
 *
 * Все они читают его отсюда. Значение выставляется мутацией Vuex `SET_SESSION` (и чистится
 * `CLEAR_SESSION`), поэтому при перезагрузке страницы, где память пуста, оно восстанавливается
 * тем же путём, что и сессия — через `whoami` по cookie в router guard.
 *
 * Модуль СПЕЦИАЛЬНО без импортов: его тянут и сервисы, и стор, и jwtService — любой статический
 * импорт создал бы цикл. Здесь только переменная модуля.
 */
let sessionToken = ''

export function setSessionToken(token) {
  sessionToken = token || ''
}

export function getSessionToken() {
  return sessionToken
}
